import { lotame } from '@tunein/web-common';
import { storeSingleton } from 'src/client/store/storeSingleton';
import oneTrust from 'src/common/consent/OneTrust';
import {
  selectGdprApplies,
  selectGdprTcString,
  selectIsOptedOutOfTargeting,
  selectUsPrivacyString,
} from 'src/common/selectors/app';

export async function buildConsentData() {
  await oneTrust.ready;

  const state = storeSingleton.state;
  const gdprApplies = selectGdprApplies(state);
  const audiences = lotame.getAudiences();
  const isOptedOutOfTargeting = selectIsOptedOutOfTargeting(state);

  return {
    gdprApplies,
    gdprTcString: selectGdprTcString(state),
    usPrivacyString: selectUsPrivacyString(state),
    optedInGeneralVendorIds: gdprApplies ? await oneTrust.getOptedInGeneralVendorIds() : undefined,
    isTargetingEnabled: !isOptedOutOfTargeting,
    audiences,
  };
}
